import React from 'react';
export function TourismSection() {
  return <div className="bg-white py-12" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4" data-id="element-231">
        <div className="grid md:grid-cols-2 gap-8 items-center mb-8" data-id="element-232">
          <div data-id="element-233">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-234">
              Turismo e Lazer
            </h2>
            <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-235">
              Ver mais
            </button>
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-236">
            <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600" alt="Turismo Marítimo" className="w-full h-full object-cover" data-id="element-237" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-238">
              <h3 className="text-xl font-bold mb-2" data-id="element-239">Atividades Náuticas</h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-240">
                Explorar
              </button>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-241">
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-242">
            <img src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600" alt="Desportos Aquáticos" className="w-full h-full object-cover" data-id="element-243" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-244">
              <h3 className="text-lg font-bold mb-2" data-id="element-245">Desportos Aquáticos</h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-246">
                Explorar
              </button>
            </div>
          </div>
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-247">
            <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600" alt="Turismo Costeiro" className="w-full h-full object-cover" data-id="element-248" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-249">
              <h3 className="text-lg font-bold mb-2" data-id="element-250">
                Praias e Zonas Costeiras
              </h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-251">
                Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}